export const LOCALE_CODE_FI = 'fi';
export const LOCALE_CODE_EN = 'en';
export const SUPPORTED_LOCALES = [LOCALE_CODE_FI, LOCALE_CODE_EN];
export const AD_TYPE_FORSALE_EN = 'forsale';
export const AD_TYPE_FORRENT_EN = 'forrent';
export const AD_TYPE_FORRENT_FI = 'vuokrataan';
export const AD_STATUS_FORSALE = 'forsale';
export const AD_STATUS_SOLD = 'sold';
export const AD_STATUS_ON_HOLD = 'onhold';
export const AD_STATUS_EXPIRED = 'expired';
export const COUNTRY_FINLAND_ID = 73;
export const REGION_OUTSIDE_FINLAND_ID = 15;
export const REGION_FINLAND_ID = 0;
export const COUNTRY_PREFIX = 'c';
export const AD_LISTING_URL_SUFFIX = 'vaihtoautot';
export const SEARCH_AD_LISTING_PREFIX = 'hakutulokset';
export const MAX_MILEAGE = 999999999;
export const MIN_MILEAGE = 0;

export const commonUtils = {
    isStartChatCliked: false,
    zarazClickEventTriggered: false,
    mapHeight: 544,
    mapWidth: 631,
    zoomLevel: 12,
    init() {
        // Global guard: block Zaraz synthetic re-clicks from reaching site JS handlers.
        // Zaraz sets isSynthetic=true on the MouseEvent it dispatches after its 500ms delay (see s.js).
        // Running in capture phase (true) ensures this fires before any jQuery bubble-phase handlers.
        // For real user clicks, event.isSynthetic is undefined → condition is false → zero effect.
        document.addEventListener(
            'click',
            function (event) {
                if (event.isSynthetic && event.target instanceof Element && event.target.closest('[data-gtm-name]')) {
                    event.stopImmediatePropagation();
                }
            },
            true
        );

        let $body = $('body');
        $(document).on('click', '.changeUserProfileLanguage', function () {
            commonUtils.changeUserProfileLanguage($(this));
        });

        $body.on('click', '#hideNewsBar', function () {
            commonUtils.hideNewsBar($(this));
        });

        // Post ad button for sketch ad
        $body.on('click', '.postAdButton', function () {
            if (
                $('.postAdButton')
                    .html()
                    .match(/sketch-ad/i)
            ) {
                $.colorbox({ fixed: true, inline: true, href: '#post_box' });
                return false;
            }
            return undefined;
        });

        // Play video from popup
        $body.on('click', '.playEmbedVideo', function () {
            let videoType = $(this).data('videotype');
            let videoHash = $(this).data('videohash');
            let autoPlay = $(this).data('autoplay');
            let autoHide = $(this).data('autohide');
            let rel = $(this).data('rel');
            let controls = $(this).data('controls');

            if (videoType === 'youtube' && !window.$('#cmp_consent').data('youtube')) {
                commonUtils.showConsentMessage();
                return false;
            }

            let params = autoPlay === true ? '&autoplay=1' : '&autoplay=0';
            params += autoHide === true ? '&autohide=1' : '&autohide=0';
            params += rel === true ? '&rel=1' : '&rel=0';
            params += controls === true ? '&controls=1' : '&controls=0';
            params += videoType === 'vimeo' ? '&dnt=1' : '';

            let youtubeEmbedUrl = `//www.youtube-nocookie.com/embed/${videoHash}${params ? `?${params}` : ''}`;
            let vimeoEmbedUrl = `//player.vimeo.com/video/${videoHash}${params ? `?${params}` : ''}`;

            $.colorbox({
                html: `<div class="color-box__video-box"><div class="responsive-video-wrapper"><iframe width="100%" height="auto" src="${videoType === 'youtube' ? youtubeEmbedUrl : vimeoEmbedUrl}"></iframe></div></div>`,
            });
            return undefined;
        });

        // Small screen header menu dropdown
        $('#sisterSiteDropDown').on('click', function () {
            $('.top-bar').toggleClass('showHideSisterSiteMenu');
            $('#sisterSiteDropDown').toggleClass('Sister_Site_Menu_Opened');
        });

        // Close user menu
        $body.on('click', '.closeUserMenu', function () {
            let $loginBox = $('#loginBox');
            $loginBox.removeClass('menu-open-arrow');
            $loginBox.next().removeClass('nettixMenuOpened');
        });

        this.showHideCustomMenu();
        this.colorBoxEvent();

        // Collapsible section of oma-nettix links for private user dropdown
        $body.on('click', '.subMenuTitleLink', function (event) {
            event.stopPropagation();
            const shouldContinue = commonUtils.handleZarazEvent($(this));
            if (!shouldContinue) {
                return;
            }
            $(this).parent().closest('.subMenuParent').toggleClass('user-section__logged-in-dropdownOpen');
            // need to show /hide the shortcuts menu for mobile view.
            $(this).parent().closest('.subMenuParent').find('.shortcutsMenuDropdown').toggle();
        });

        // also close dmsFinanceTooltip if clicked outside
        $(document).on('click', function (event) {
            if (!$(event.target).closest('.dmsFinanceInfo, .dmsFinanceTooltip').length) {
                $('.dmsFinanceInfo').removeClass('financeTooltipOpened');
            }
        });

        // dmsFinance show/ hide
        $body.on('click', '.dmsFinanceInfo', function () {
            const isOpen = $(this).hasClass('financeTooltipOpened');
            $('.dmsFinanceInfo').removeClass('financeTooltipOpened');
            if (!isOpen) {
                $(this).addClass('financeTooltipOpened');
            }
        });
    },
    getAppObject() {
        return $('#app');
    },
    googleMapApiKey() {
        return `https://www.google.com/maps/embed/v1/place?language=${LOCALE_CODE_FI}&key=${this.getAppObject().data('google-map-api-key')}`;
    },
    bonusLogoCounter(id) {
        $.get(Routing.generate('bonus_logo_counter', { id }));
    },
    continueSketchAd() {
        window.location.href = `${commonUtils.getSiteBaseUrl()}/jata-uusi-ilmoitus`;
        window.$.colorbox.close();
    },
    deleteSketchAdData() {
        $.get(`${commonUtils.getSiteBaseUrl()}/jata-uusi-ilmoitus/sketch/remove`, function () {
            location.href = `${commonUtils.getSiteBaseUrl()}${!commonUtils.isDealerLogin() && commonUtils.isNettiauto() ? '/myy-autosi' : '/jata-uusi-ilmoitus'}`;
        });
    },
    colorBoxEvent() {
        // disable scroll window when colorbox is open
        let cboxposition;
        $(document)
            .bind('cbox_open', function () {
                cboxposition = $('html,body').scrollTop();
                $('html').css({ overflow: 'hidden' });
            })
            .bind('cbox_closed', function () {
                $('html').css({ overflow: 'initial' });
                $('html,body').scrollTop(cboxposition);
            });
    },
    showHideToggle(id) {
        $(`#${id}`).toggle();
    },
    handleZarazEvent(target) {
        // Prevents double click on zaraz event
        if (target.attr('data-gtm-name')) {
            if (this.zarazClickEventTriggered) {
                this.zarazClickEventTriggered = false;
                return false;
            }
            setTimeout(() => {
                this.zarazClickEventTriggered = true;
                setTimeout(() => {
                    this.zarazClickEventTriggered = false;
                }, 500);
            }, 0);
            return true;
        }
        this.zarazClickEventTriggered = false;
        return true;
    },
    showHideCustomMenu() {
        // Extract menu toggle logic to a reusable function
        const toggleMenu = (target) => {
            // Check if the target or its parent has nettixMenu class
            const menuElement = target.hasClass('nettixMenu') ? target : target.parent('.nettixMenu');

            if (!menuElement.length || menuElement.hasClass('removeAdFromHidden')) {
                return false;
            }

            // Check for Zaraz event tracking
            const shouldContinue = commonUtils.handleZarazEvent(target);
            if (!shouldContinue) {
                return false;
            }

            const menuContent = menuElement.next();

            // Toggle menu - if already open, close it; if closed, open it
            if (menuContent.hasClass('nettixMenuOpened')) {
                // Close this menu since it's already open
                menuContent.hide().removeClass('nettixMenuOpened');
                menuElement.removeClass('menu-open-arrow');
                return true;
            }
            // Hide any other open menus first
            commonUtils.hideOpenedMenu();
            menuContent.show().addClass('nettixMenuOpened');
            menuElement.addClass('menu-open-arrow');
            return true;
        };

        // Click handler
        $('body').on('click', function (e) {
            const target = $(e.target);

            // Handle menu toggle clicks
            if (target.hasClass('nettixMenu') || target.parent().hasClass('nettixMenu')) {
                toggleMenu(target);
            } else if (!target.parent().hasClass('nettixMenuOpened')) {
                // Hide menu if click outside nettixMenu section
                commonUtils.hideOpenedMenu();
            }

            // Hide pagination goto form
            if (!target.closest('.pagination__dots').length) {
                $('.pagination__input-number').hide();
            }

            // Nettiauto listing page: Hide tooltip when click outside
            if (
                !target.hasClass('warrantyTooltip') &&
                !target.hasClass('warrantyTooltipText') &&
                $('.warrantyTooltipText').length
            ) {
                $('.warrantyTooltipText').addClass('none');
            }
        });

        // Keyboard accessibility for the menu triggers
        $(document).on('keydown', '.nettixMenu', function (e) {
            const target = $(e.target);

            // Enter key to open/close menu (like a click)
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                toggleMenu(target);
            }
        });

        // Global keyboard accessibility - handle Escape key anywhere
        $(document).on('keydown', function (e) {
            // Escape key to close menu regardless of focus location
            if ((e.key === 'Escape' || e.keyCode === 27) && $('.nettixMenuOpened').length) {
                if ($('.nettixMenuOpened').length > 0) {
                    $('.nettixMenuOpened').prev('.nettixMenu')[0]?.focus({ preventScroll: true });
                    commonUtils.hideOpenedMenu();
                }
            }
        });

        // Initialize tabindex for keyboard navigation
        $('.nettixMenu').attr('tabindex', '0').attr('role', 'button');
    },
    hideOpenedMenu() {
        $('.nettixMenuOpened').hide().removeClass('nettixMenuOpened');
        $('.nettixMenu').removeClass('menu-open-arrow');
    },
    typewatch(callback, ms) {
        let timer = 0;

        function exec() {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }

        return exec();
    },
    hideNewsBar(object) {
        $('#newsBar').remove();
        let newsId = object.data('newsid');
        let frequency = object.data('frequency');
        let minutes = 60 * 24;
        if (frequency === 'once') {
            minutes = 60 * 24 * 365;
        } else if (frequency === 'once_per_week') {
            minutes = 60 * 24 * 7;
        }
        this.setCookie(`__newsBar${newsId}`, 1, minutes);
    },
    changeUserProfileLanguage(element) {
        let languageCode = element.data('language-code');
        let redirectionUrl = element.attr('href');

        if ($.inArray(languageCode, SUPPORTED_LOCALES) < 0) {
            return false;
        }

        if (commonUtils.isDealerLogin()) {
            window.location.href = redirectionUrl;
            return true;
        }

        $.post(Routing.generate('update_profile_language'), `languageCode=${languageCode}`, function () {
            window.location.href = redirectionUrl;
        });
        return undefined;
    },
    throttle(delay, no_trailingInput, callbackInput, debounce_modeInput) {
        // https://github.com/cowboy/jquery-throttle-debounce/
        // After wrapper has stopped being called, this timeout ensures that
        // `callback` is executed at the proper times in `throttle` and `end`
        // debounce modes.
        let timeout_id,
            // Keep track of the last time `callback` was executed.
            last_exec = 0;

        let debounce_mode = debounce_modeInput;
        let callback = callbackInput;
        let no_trailing = no_trailingInput;

        // `no_trailing` defaults to falsy.
        if (typeof no_trailing !== 'boolean') {
            debounce_mode = callback;
            callback = no_trailing;
            no_trailing = undefined;
        }

        // The `wrapper` function encapsulates all of the throttling / debouncing
        // functionality and when executed will limit the rate at which `callback`
        // is executed.
        function wrapper(...args) {
            let that = this,
                elapsed = +new Date() - last_exec;

            // Execute `callback` and update the `last_exec` timestamp.
            function exec() {
                last_exec = +new Date();
                callback.apply(that, args);
            }

            // If `debounce_mode` is true (at_begin) this is used to clear the flag
            // to allow future `callback` executions.
            function clear() {
                timeout_id = undefined;
            }

            if (debounce_mode && !timeout_id) {
                // Since `wrapper` is being called for the first time and
                // `debounce_mode` is true (at_begin), execute `callback`.
                exec();
            }

            // Clear any existing timeout.
            if (timeout_id) {
                clearTimeout(timeout_id);
            }

            if (debounce_mode === undefined && elapsed > delay) {
                // In throttle mode, if `delay` time has been exceeded, execute
                // `callback`.
                exec();
            } else if (no_trailing !== true) {
                // In trailing throttle mode, since `delay` time has not been
                // exceeded, schedule `callback` to execute `delay` ms after most
                // recent execution.
                //
                // If `debounce_mode` is true (at_begin), schedule `clear` to execute
                // after `delay` ms.
                //
                // If `debounce_mode` is false (at end), schedule `callback` to
                // execute after `delay` ms.
                timeout_id = setTimeout(
                    debounce_mode ? clear : exec,
                    debounce_mode === undefined ? delay - elapsed : delay
                );
            }
        }

        // Set the guid of `wrapper` function to the same of original callback, so
        // it can be removed in jQuery 1.4+ .unbind or .die by using the original
        // callback as a reference.
        if ($.guid) {
            callback.guid = callback.guid || $.guid++;
            wrapper.guid = callback.guid;
        }

        return wrapper;
    },
    setCookie(name, value, minutes) {
        let d = new Date();
        d.setTime(d.getTime() + minutes * 60 * 1000);
        let expires = `expires=${d.toUTCString()}`;
        document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
    },
    getCookie(name) {
        let result = null;
        let myCookie = ` ${document.cookie};`;
        let searchName = ` ${name}=`;
        let startOfCookie = myCookie.indexOf(searchName);
        let endOfCookie;
        if (startOfCookie !== -1) {
            startOfCookie += searchName.length;
            endOfCookie = myCookie.indexOf(';', startOfCookie);
            result = decodeURIComponent(myCookie.substring(startOfCookie, endOfCookie));
        }
        return result;
    },
    deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/;`;
    },
    redirectCategoryUrl(element) {
        window.open($(element).val(), $(element).find(':selected').data('target'));
    },
    redirectToCleanUrl(type, slug) {
        let redirectUrl = window.location.origin;

        switch (type) {
            case 'make':
                if (this.isNettikaravaani()) {
                    redirectUrl = Routing.generate('ad_listing', {
                        arg1: this.formatUri(slug, ['+']),
                        arg2: SEARCH_AD_LISTING_PREFIX,
                    });
                } else {
                    redirectUrl = Routing.generate('ad_listing', { arg1: this.formatUri(slug) });
                }
                break;
            case 'vehicleClass':
                redirectUrl = Routing.generate('ad_listing', {
                    arg1: this.formatUri(slug),
                    arg2: SEARCH_AD_LISTING_PREFIX,
                });
                break;
            default:
                break;
        }

        location.href = redirectUrl;
    },
    formatUri(strInput, replace) {
        // Pass e.g. ['+'] for Nettikaravaani: "Niesmann+Bischoff" → "niesmann-bischoff"
        // without affecting other verticals where + is valid in slugs (qashqai+2).
        let str = strInput;
        if (replace && replace.length) {
            replace.forEach(function (char) {
                str = str.split(char).join(' ');
            });
        }
        let rExps = [
            { re: /[\xC0-\xC6]/gi, ch: 'A' },
            { re: /[\xE0-\xE6]/gi, ch: 'a' },
            {
                re: /[\xC8-\xCB]/gi,
                ch: 'E',
            },
            { re: /[\xE8-\xEB]/gi, ch: 'e' },
            { re: /[\xCC-\xCF]/gi, ch: 'I' },
            {
                re: /[\xEC-\xEF]/gi,
                ch: 'i',
            },
            { re: /[\xD2-\xD6]/gi, ch: 'O' },
            { re: /[\xF2-\xF6]/gi, ch: 'o' },
            {
                re: /[\xD9-\xDC]/gi,
                ch: 'U',
            },
            { re: /[\xF9-\xFC]/gi, ch: 'u' },
            { re: /[\xD1]/gi, ch: 'N' },
            {
                re: /\xF1/gi,
                ch: 'n',
            },
            { re: /[^a-z\d/_|+ -]/gi, ch: '' },
            { re: /[/_| -]+/gi, ch: '-' },
        ];

        for (let i = 0, len = rExps.length; i < len; i++) {
            str = str.replace(rExps[i].re, rExps[i].ch);
        }

        return str.toLowerCase();
    },
    number_format(numberInput, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        const number = `${numberInput}`.replace(/[^0-9+\-Ee.]/g, '');
        let n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
            dec = typeof dec_point === 'undefined' ? '.' : dec_point,
            s = '',
            toFixedFix = function (num, exponent) {
                let k = 10 ** exponent;
                return `${Math.round(num * k) / k}`;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },
    isElementInViewport(elementInput) {
        const element = typeof jQuery === 'function' && elementInput instanceof jQuery ? elementInput[0] : elementInput;

        // Get computed style of the element
        const style = window.getComputedStyle(element);
        // Check if element is visible
        if (!element || element.offsetParent === null || style.display === 'none' || style.visibility === 'hidden') {
            return false; // Element is not visible
        }

        let domRect = element.getBoundingClientRect();
        return (
            domRect.top >= 0 &&
            domRect.left >= 0 &&
            domRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            domRect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
    isAndroid(userAgentInput) {
        const userAgent = userAgentInput || window.navigator.userAgent;
        return /android/i.test(userAgent);
    },
    isiOS(userAgentInput) {
        const userAgent = userAgentInput || window.navigator.userAgent;
        return /iPad|iPhone|iPod/.test(userAgent);
    },
    isMobileView() {
        return $(window).width() <= 480;
    },
    isTabletView() {
        return $(window).width() > 480 && $(window).width() <= 1024;
    },
    isDesktopView() {
        // isiOS() is added here because in ipad view it displays mobile view page
        return !this.isMobileView() && !this.isiOS();
    },
    isSearchModalDesktopView() {
        return $(window).width() > 651;
    },
    hideElementOnMobileView() {
        if (commonUtils.isMobileView()) {
            $('.showOnLargeView').remove();
            // Listing page
            if ($('[data-url="largeView"]').length) {
                $('[data-url="largeView"]').removeAttr('target');
            }
        } else {
            $('.showOnMobileView').remove();
        }
    },
    startDealerChat(adId, chatProviderId, chatProvider) {
        let chatProviderName = chatProvider[chatProviderId];
        if (!chatProviderName) {
            return false;
        }

        let $openDealerChat = $('.openDealerChat');
        let $openStickyDealerChat = $('.openStickyDealerChat');
        $openDealerChat.addClass('add-chat__button-loading');
        $openStickyDealerChat.addClass('chat-is-loading');

        this.dataLayer.dealerChat();

        setTimeout(function () {
            if ($openDealerChat.hasClass('add-chat__button-loading')) {
                $openDealerChat.removeClass('add-chat__button-loading');
            }
            if ($openStickyDealerChat.hasClass('chat-is-loading')) {
                $openStickyDealerChat.removeClass('chat-is-loading');
            }
        }, 6000);

        if (!this.isStartChatCliked) {
            window.counters.incrementByAdId(chatProviderName, adId);
            this.isStartChatCliked = true;
        }
        return undefined;
    },
    base64ToUint8Array(base64String) {
        // Decode the base64-encoded string to a binary string
        const binaryString = atob(base64String);

        // Convert binary string to a Uint8Array
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }

        return byteArray;
    },
    isAppleDevice() {
        const { userAgent } = navigator;
        const isIOS =
            /iPad|iPhone|iPod/.test(userAgent) || (userAgent.includes('MacIntel') && navigator.maxTouchPoints > 1); // Detects iOS/iPadOS
        const isMac =
            (userAgent.includes('Macintosh') || userAgent.includes('Mac OS X')) && navigator.maxTouchPoints === 0; // Detects macOS excluding iPadOS

        return isIOS || isMac;
    },
    showNotification(message, showTimeInput, idToShowMessage) {
        let msgDisplayHeight = $('#shareLinkForm').length ? $('#shareLinkForm').height() : 0;
        const showTime = typeof showTimeInput !== 'undefined' ? showTimeInput : 3000;
        if (typeof idToShowMessage !== 'undefined') {
            msgDisplayHeight = $(`#${idToShowMessage}`).height();
        }

        let $window = $(window);
        let $notificationBox = $('#notificationBox');

        $notificationBox.show();
        $('#notificationBoxMessage').html(message);
        $notificationBox.css(
            'top',
            ($window.height() - msgDisplayHeight - $notificationBox.height()) / 2 + $window.scrollTop()
        );
        $notificationBox.css('left', ($window.width() - $notificationBox.width()) / 2 + $window.scrollLeft());
        $notificationBox.fadeOut(showTime);
    },
    changeFromToOptions(value1, value2Input, selectedValueInput, optionValueOrderInput) {
        let start = value1.selectedIndex < 1 ? 1 : value1.selectedIndex;
        let total = value1.length;
        let display = '';
        const optionValueOrder = optionValueOrderInput || 'asc';
        const value2 = value2Input;
        let selectedValue = selectedValueInput;

        if ('desc' === optionValueOrder.toLowerCase()) {
            start = 1;
            total = value1.selectedIndex + 1 === 1 ? value1.options.length - 1 : value1.selectedIndex + 1;
        }

        if (selectedValue === '' && value2.selectedIndex > 0) {
            selectedValue = value2.options[value2.selectedIndex].value;
        }
        value2.length = 1;
        for (let i = start, j = 1; i < total; j++, i++) {
            display = value1.options[i].text;

            value2.options[j] = new Option($.trim(display), value1.options[i].value);

            if (selectedValue === value1.options[i].value) {
                value2.selectedIndex = j;
            }
        }
    },
    dataLayer: {
        dealerChat() {
            let $openDealerChat = $('.openDealerChat');
            let $openStickyDealerChat = $('.openStickyDealerChat');
            try {
                dataLayer.push({
                    event: 'loadDealerChat',
                    chatLoadedCallback() {
                        // after successfully loading the script, stops the spinner
                        $openDealerChat.removeClass('add-chat__button-loading');
                        $openStickyDealerChat.removeClass('chat-is-loading');
                    },
                });
            } catch (e) {
                console.log(`chat error: ${e}`);
                $openDealerChat.removeClass('add-chat__button-loading');
                $openStickyDealerChat.removeClass('chat-is-loading');
            }
        },
        productDetailView() {
            let products = $('#dataLayerAdJson').data('ad-json');
            try {
                let dataLayerPush = {
                    event: 'view_item',
                    ecommerce: {
                        items: [products],
                    },
                };

                if (products.campaign_type) {
                    dataLayerPush.campaign_type = products.campaign_type;
                }

                dataLayer.push(dataLayerPush);
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
        contactRequest() {
            let products = $('#dataLayerAdJson').data('ad-json');
            try {
                dataLayer.push({
                    event: commonUtils.isNettiauto() ? 'ecom-AddToCart' : 'addToCart',
                    eventCategory: 'Liidi',
                    eventAction: 'Yhteydenotto',
                    ecommerce: {
                        add: {
                            products: [products],
                        },
                    },
                });
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
        genericDataLayerEvent(eventName) {
            if (eventName) {
                try {
                    dataLayer.push({
                        event: eventName,
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            }
        },
        vifPageCallLeadDataLayerEvent(callType, location) {
            if (callType) {
                try {
                    dataLayer.push({
                        event: 'generate_lead',
                        lead_type: 'call',
                        call_type: callType,
                        location,
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            }
        },
        replaceBlankWithUndefined(dataInput) {
            const data = dataInput;
            Object.keys(data).forEach((key) => {
                if (data[key] === '') {
                    data[key] = undefined;
                }
            });

            return data;
        },
        genericData(data) {
            try {
                dataLayer.push(data);
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
        shareButtonDataLayerEvent(shareType) {
            if (shareType) {
                try {
                    dataLayer.push({
                        event: 'shareButton',
                        shareType,
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            }
        },
        showInsuranceButtonDataLayerEvent(insurances) {
            $.each(insurances, function (index) {
                try {
                    dataLayer.push({
                        event: 'vakuutusNaytaTarjous',
                        insuranceName: insurances[index],
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            });
        },
        getInsuranceButtonDataLayerEvent(insuranceName) {
            if (insuranceName) {
                try {
                    dataLayer.push({
                        event: 'vakuutusLaskeJaOsta',
                        insuranceName,
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            }
        },
        viewFinanceButtonDataLayerEvent(financeCalculators) {
            $.each(financeCalculators, function (index) {
                try {
                    dataLayer.push({
                        event: 'rahoitusNaytaTarjous',
                        bankName: financeCalculators[index],
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            });
        },
        getLoanButtonDataLayerEvent(bankName) {
            if (bankName) {
                try {
                    dataLayer.push({
                        event: 'rahoitusHaeLainaa',
                        bankName,
                    });
                } catch (_e) {
                    // ignore dataLayer errors
                }
            }
        },
        dataLayerEventWithLink(bankName, linkText, linkTarget) {
            try {
                dataLayer.push({
                    event: 'rahoitusTextLink',
                    bankName,
                    linkText,
                    linkTarget,
                });
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
        productListImpressionDataLayerEvent(datalayerData, listLocation, listName, pageNumber = '') {
            try {
                dataLayer.push({
                    ecommerce: null,
                });
                dataLayer.push({
                    event: 'view_item_list',
                    ecommerce: {
                        item_list_id: listName,
                        item_list_name: listName,
                        item_list_location: listLocation,
                        page_number: pageNumber,
                        items: datalayerData,
                    },
                });
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
        productListClickDataLayerEvent(datalayerData, listLocation, listName, pageNumber = '') {
            try {
                dataLayer.push({
                    ecommerce: null,
                });
                dataLayer.push({
                    event: 'select_item',
                    ecommerce: {
                        item_list_id: listName,
                        item_list_name: listName,
                        item_list_location: listLocation,
                        page_number: pageNumber,
                        items: [datalayerData],
                    },
                });
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
        genericPageViewDataLayerEvent(eventName, pageName) {
            try {
                dataLayer.push({
                    event: eventName,
                    page: pageName,
                });
            } catch (_e) {
                // ignore dataLayer errors
            }
        },
    },
    adminBubbleMessage: {
        showBubbleMessage() {
            $.colorbox({
                inline: true,
                href: '#adminBubbleMessageContent',
                escKey: false,
                overlayClose: false,
                close: '',
            });
        },
        updateUserReadAdminMessage() {
            $.ajax({
                type: 'POST',
                url: Routing.generate('ajax_update_user_read_message'),
                data: $('#adminBubbleMessage').serialize(),
                success() {
                    $('#overlay').remove();
                    $('#lightbox').hide();
                    $.colorbox.close();
                },
            });

            return false;
        },
    },
    getWindowScrollPosition() {
        if (typeof self.scrollY !== 'undefined') {
            return self.scrollY;
        }
        if (typeof document.documentElement.scrollTop !== 'undefined') {
            return document.documentElement.scrollTop;
        }
        return undefined;
    },
    scrollToElement(id) {
        let winScrollPos = this.getWindowScrollPosition();
        if (winScrollPos > 0) {
            $('html,body').animate({ scrollTop: $(`#${id}`).offset().top }, { duration: 500 });
        }
    },
    getVerticalName() {
        return commonUtils.getAppObject().data('vertical-name');
    },
    isNettiauto() {
        return 'Nettiauto' === this.getVerticalName();
    },
    isNettimoto() {
        return 'Nettimoto' === this.getVerticalName();
    },
    isNettivene() {
        return 'Nettivene' === this.getVerticalName();
    },
    isNettikone() {
        return 'Nettikone' === this.getVerticalName();
    },
    isNettikaravaani() {
        return 'Nettikaravaani' === this.getVerticalName();
    },
    isNettivaraosa() {
        return 'Nettivaraosa' === this.getVerticalName();
    },
    isUserLogin() {
        return this.getAppObject().data('is-user-login');
    },
    isDealerLogin() {
        return this.getAppObject().data('is-dealer-login');
    },
    isProductionEnvironment() {
        return this.getAppObject().data('is-production-environment');
    },
    getCurrentLocale() {
        let locale = $('html')[0].lang;
        return $.inArray(locale, SUPPORTED_LOCALES) !== -1 ? locale : LOCALE_CODE_FI;
    },
    isDevEnvironment() {
        return this.getAppObject().data('is-dev-environment');
    },
    openNewWindow(url, width, height, titleInput, leftInput, topInput, isNewWindowInput) {
        const isNewWindow = isNewWindowInput || '';
        const left = leftInput === '' ? 0 : leftInput;
        const top = topInput === '' ? 0 : topInput;
        const title = titleInput === '' ? 'New' : titleInput;

        let settings = `width=${width},height=${height},left=${left},top=${top},directories=no,location=no,menubar=no,status=yes,titlebar=no,toolbar=no,resizable=no,scrollbars=no`;
        let newWindow = isNewWindow ? window.open(url, title) : window.open(url, title, settings);

        newWindow.focus();
    },
    isObjectEmpty(object) {
        return Object.keys(object).length === 0;
    },
    isEmpty(string) {
        let isValidString = true;
        $.each(string.split(''), function (value) {
            if (' ' !== value && '\n' !== value && '\t' !== value) {
                isValidString = false;
            }
        });

        return isValidString;
    },
    isValidString(string) {
        return string.match(/^[a-zA-Z-åÅäÄöÖüÜÁÀÉÈÒÓÙÚáàèéòóùúÝìíýÌÍ\s]+$/);
    },
    checkLength(string, length) {
        return string.length >= length;
    },
    isLongWord(eleValue, len) {
        if (eleValue === '') {
            return true;
        }
        let tempValue = eleValue.split(/\s+/);
        for (let value of tempValue) {
            if (value.length > len) {
                return false;
            }
        }

        return true;
    },
    isValidZip(string) {
        let isValidZip = true;
        if (!string.match(/^[0-9a-zA-Z,\s-]{1,250}$/)) {
            isValidZip = false;
        }

        return isValidZip;
    },
    isValidEmail(email) {
        let isValidEmail = true;
        if (!email.match(/^\w+([.+]?[-]{0,2}\w+)*[.]?[-]?@\w+([.-]?\w+)*(\.\w{2,22})+$/i)) {
            isValidEmail = false;
        }

        return isValidEmail;
    },
    isValidPhone(phone) {
        return phone.match(/^[\d\s+-]{5,25}$/);
    },
    isAlphaNumeric(string) {
        return string.match(/^[\da-zA-ZåÅäÄöÖüÜÁÀÉÈÒÓÙÚáàèéòóùúÝìíýÌÍ´\s-]+$/);
    },
    isValidRegistrationNumber(registrationNumber) {
        return (
            !registrationNumber.match(/^([a-zA-ZäÄÖöÅå]{1,3})-?(\d{1,3})$/) &&
            !registrationNumber.match(/^(\d{1,3})-?([a-zA-ZäÄÖöÅå]{1,3})$/)
        );
    },
    isValidVIN(vin) {
        const hasLetter = /[a-zA-Z]/.test(vin);
        const hasNumber = /\d/.test(vin);
        const isCorrectLength = vin.length >= 8 && vin.length <= 19;
        return hasLetter && hasNumber && isCorrectLength;
    },
    isValidUrl(url) {
        return url.match(/^(http|https):\/\/[a-zA-Z0-9-]+\.[a-zA-Z]{2,5}\.?/);
    },
    showConfirmationPrompt(message, redirectUrl) {
        let homePageUrl = Routing.generate('home_page');
        if (confirm(message)) {
            location.href = redirectUrl ?? homePageUrl;
        }

        return false;
    },
    showConsentMessage() {
        window.$.colorbox({ inline: true, scrolling: false, href: '#consetModal' });
    },
    allowInteger(object) {
        object.val(
            object
                .val()
                .replace(/\D/g, '')
                .replace(/(\..*)\./g, '$1')
        );
    },
    allowDecimal(object) {
        let val = object.val().replaceAll(/[^0-9.,]/g, '');
        val = val.replaceAll(',', '.'); // normalize comma to dot
        // Keep only the first decimal point
        const parts = val.split('.');
        if (parts.length > 2) {
            val = `${parts[0]}.${parts.slice(1).join('')}`;
        }
        object.val(val);
    },
    generateRandomNumber(max = 100000) {
        const typedArray = new Uint32Array(1);
        crypto.getRandomValues(typedArray);
        return typedArray % max;
    },
    getQueryString(keyInput, defaultValue, explicitQueryStringInput) {
        const explicitQueryString = explicitQueryStringInput || '';
        const key = keyInput.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
        let regex = new RegExp(`[\\?&]${key}=([^&#]*)`);
        let queryString = regex.exec(explicitQueryString || window.location.href);

        return queryString === null ? defaultValue : queryString[1];
    },
    loadCloudFlareTurnstileJs() {
        // Cloudflare Turnstile validation is for non-login user only
        if (commonUtils.isUserLogin() || commonUtils.isDevEnvironment()) {
            return Promise.resolve(null);
        }

        return new Promise((resolve, reject) => {
            const existingScript = document.getElementById('cloudflareTurnstileJs');
            if (!existingScript) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
                script.id = 'cloudflareTurnstileJs';
                script.async = true;
                script.onload = () => resolve(script);
                script.onerror = () => reject(new Error('Script load error!'));
                document.head.appendChild(script);
            } else {
                resolve(null);
            }
        });
    },
    initializeTurnstile(elementId) {
        if (window.turnstile && $(elementId).data('sitekey')) {
            const sitekey = $(elementId).data('sitekey');
            window.turnstile.render(elementId, {
                sitekey,
            });
        }
    },
    loadTurnstileScriptAndRenderWidget(elementId) {
        commonUtils
            .loadCloudFlareTurnstileJs()
            .then(() => {
                commonUtils.initializeTurnstile(elementId);
            })
            .catch((error) => {
                console.error('Error loading Cloudflare Turnstile script:', error);
            });
    },
    loadEmbedMap(address, container, custom_height, custom_width, zoom) {
        let iframe = document.createElement('iframe');
        iframe.style.border = '0';
        iframe.height = custom_height > 0 ? custom_height : this.mapHeight;
        iframe.width = custom_width > 0 ? custom_width : this.mapWidth;
        let zoomLevel = zoom > 0 ? zoom : this.zoomLevel;
        iframe.src = `${commonUtils.googleMapApiKey()}&zoom=${zoomLevel}&q=${address}`;
        $(`#${container}`).html(iframe);
    },
    isTouchDevice() {
        let el = document.createElement('div');
        el.setAttribute('ongesturestart', 'return;'); // or try "ontouchstart"
        return typeof el.ongesturestart === 'function';
    },
    getVerifyAdLinkUtmParameters() {
        let utmString = '';

        if (commonUtils.isNettiauto()) {
            utmString =
                '&utm_source=nettiauto.com&utm_medium=almainternal&utm_campaign=kiintea_auto_varmennettuilmoitus&utm_content=kiintea_painike_jatka';
        }

        return utmString;
    },
    getVerifyAdLink(registerNumber, vertical) {
        return `${commonUtils.getAppObject().data('oma-nettix-url')}/lisaa-ajoneuvo?isVerificationProcess=true&regNumber=${window.btoa(registerNumber)}&vertical=${vertical}${commonUtils.getVerifyAdLinkUtmParameters()}`;
    },
    mergeObjects(obj1, obj2) {
        const mergedObj = { ...obj1 };

        for (const key in obj2) {
            if (Object.prototype.hasOwnProperty.call(obj2, key)) {
                if (
                    typeof obj2[key] === 'object' &&
                    obj2[key] !== null &&
                    typeof mergedObj[key] === 'object' &&
                    mergedObj[key] !== null
                ) {
                    mergedObj[key] = this.mergeObjects(mergedObj[key], obj2[key]); // Recursively merge nested objects
                } else {
                    mergedObj[key] = obj2[key]; // Add or overwrite key in merged object
                }
            }
        }

        return mergedObj;
    },
    select2CustomMatchForGroup(params, data) {
        // If there are no search terms, return all the data
        if ($.trim(params.term) === '') {
            return data;
        }

        // Skip if there is no 'children' property
        if (typeof data.children === 'undefined') {
            return null;
        }

        // `data.children` contains the actual options that we are matching against
        let filteredChildren = [];
        $.each(data.children, function (idx, child) {
            if ($.trim(child.text).toUpperCase().indexOf(params.term.toUpperCase()) === 0) {
                filteredChildren.push(child);
            }
        });

        // If we matched any of the timezone group's children, then set the matched children on the group
        // and return the group object
        if (filteredChildren.length) {
            let modifiedData = $.extend({}, data, true);
            modifiedData.children = filteredChildren;

            // You can return modified objects from here
            // This includes matching the `children` how you want in nested data sets
            return modifiedData;
        }

        // Return `null` if the term should not be displayed
        return null;
    },
    select2CustomMatch(params, data) {
        // If there are no search terms, return all the data
        if ($.trim(params.term) === '') {
            return data;
        }

        // Do not display the item if there is no 'text' property
        if (typeof data.text === 'undefined') {
            return null;
        }

        // `params.term` should be the term you are searching for
        // `data.text` is the text of the option element
        if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) === 0) {
            return data;
        }

        // Return `null` if the term should not be displayed
        return null;
    },
    numberFormatByLocale(priceInput) {
        const price = priceInput.toString();

        if (LOCALE_CODE_FI === this.getCurrentLocale()) {
            return price.replace('.00', '').replace('.', ',');
        }

        return price.replace('.00', '');
    },
    showTextAreaLimitText(inputSelector, counterSelector, maxLengthInput) {
        const $input = $(`#${inputSelector}`);
        const $counter = $(`#${counterSelector}`);

        // Set to default maxlength
        let maxLength = commonUtils.number_format(maxLengthInput, '', '', ' ');
        $counter.text(`${$input.val().length}/${maxLength}`);

        $input.on('input', function () {
            // Remove spaces if user entering only spaces
            if (!/\S/.test($input.val())) {
                $input.val($.trim($input.val()));
            }

            const currentLength = $input.val().length;
            if (currentLength > maxLength) {
                $input.val($input.val().substring(0, maxLength));
            }

            maxLength = commonUtils.number_format(maxLength, '', '', ' ');
            $counter.text(`${$input.val().length}/${maxLength}`);
        });

        // Remove spaces on blur
        $input.on('blur', function () {
            $input.val($.trim($input.val()));
        });
    },
    getColorBoxResponsiveWidth() {
        let screenWidth = $(window).width();
        if (screenWidth <= 359) {
            return '320px'; // smaller width view
        }
        if (screenWidth <= 700) {
            return '336px'; // Mobile view
        }
        return '352px'; // Desktop view
    },
    getSiteBaseUrl() {
        let baseUrl;

        if (commonUtils.isNettiauto()) {
            baseUrl = $('#app').data('nettiauto-url') ?? '';
        } else if (commonUtils.isNettimoto()) {
            baseUrl = $('#app').data('nettimoto-url') ?? '';
        } else if (commonUtils.isNettivene()) {
            baseUrl = $('#app').data('nettivene-url') ?? '';
        } else if (commonUtils.isNettikaravaani()) {
            baseUrl = $('#app').data('nettikaravaani-url') ?? '';
        } else {
            console.warn('Unknown vertical detected in getSiteBaseUrl');
            baseUrl = '';
        }

        // Remove trailing slash if it exists
        if (baseUrl && baseUrl.endsWith('/')) {
            baseUrl = baseUrl.slice(0, -1);
        }

        // Append the locale parameter for English if needed and not already present
        if (this.getCurrentLocale() === LOCALE_CODE_EN && baseUrl && !baseUrl.endsWith(`/${LOCALE_CODE_EN}`)) {
            return baseUrl ? `${baseUrl}/${LOCALE_CODE_EN}` : '';
        }

        return baseUrl || '';
    },
};

// Fullscreen helpers shared across sliders
commonUtils.fullscreen = {
    open(element) {
        if (!element) return;
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    },
    exit() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    },
    isActive() {
        return !!(
            document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement
        );
    },
};
